import React from 'react';
import { Layout } from 'antd';
import Header from '../shared/Header';
import AffectedUrls from '../failedChecks/AffectedUrls';
import FailedCheckDetails from '../failedChecks/FailedCheck/FailedCheckDetails';
import useUrlState from '../../hooks/useUrlState';
import DomainSetupCheck from '../websiteIndexEntry/DomainSetupCheck';
import WebsiteIndexEntrySelector from '../websiteIndexEntry/WebsiteIndexEntrySelector';
import { RouteComponentProps } from 'react-router';

const { Content } = Layout;

type Props = RouteComponentProps<{
    seoTestKey: string;
}>;

export default function FailedCheckPage({ match }: Props) {
    const seoTestKey = match.params.seoTestKey;

    const [urlState] = useUrlState();
    const { w_guid: websiteGuid } = urlState;

    return (
        <Content className="general-layout-content">
            <Header
                title={<WebsiteIndexEntrySelector />}
                showRedirectArrow
            />
            <DomainSetupCheck
                key={websiteGuid}
                websiteGuid={websiteGuid}
            >
                <FailedCheckDetails seoTestKey={seoTestKey} />
                <AffectedUrls
                    websiteGuid={websiteGuid!}
                    seoTestKey={seoTestKey}
                />
            </DomainSetupCheck>
        </Content>
    );
}
